/* RUB HUB — Image protection pilot (2026-08-16, Floody request)
   Scoped to Coast n Smoke ONLY, checked below by URL path. VERIFIED live:
   fetching /collections/coast-n-smoke-1 302/301s to the canonical
   /collections/coast-n-smoke (confirmed via canonical meta tag + final
   fetch URL on 2026-08-16), so this matches BOTH handles defensively in
   case that redirect ever changes — inert on every other page on the site.

   Finds each background slide image inside the Collection Brand Banner
   slider, copies its already-resolved src into a CSS background-image on
   the parent .rh-cbb__pic, then hides the <img> itself. A hidden element
   cannot be right-clicked or opened in a new tab, so this removes "Open
   image in new tab" / "Save image as" for the raw file — no watermark,
   nothing baked into the image, and the shared
   rh-collection-brand-banner.liquid section file is not touched at all.

   TO REMOVE / ROLL BACK: delete the single script_tag line that loads this
   file from layout/theme.liquid (search "rh-image-protect.js"), or just
   change the path check below to something that never matches. Either way
   every slide instantly goes back to a normal <img> with normal browser
   behaviour — nothing else on the site is affected either way. */
(function () {
  'use strict';

  if (!/^\/collections\/coast-n-smoke(-1)?(\/|$)/i.test(window.location.pathname)) return;

  function protect(pic) {
    if (pic.dataset.rhProtected === 'true') return;
    var img = pic.querySelector('img');
    if (!img) return;

    function apply() {
      var src = img.currentSrc || img.src;
      if (!src) return;
      pic.style.backgroundImage = 'url("' + src + '")';
      pic.style.backgroundSize = 'cover';
      pic.style.backgroundPosition = 'center';
      pic.style.webkitUserSelect = 'none';
      pic.style.userSelect = 'none';
      img.style.setProperty('display', 'none', 'important');
      pic.dataset.rhProtected = 'true';
    }

    if (img.complete && img.naturalWidth > 0) {
      apply();
    } else {
      img.addEventListener('load', apply, { once: true });
    }
  }

  function scan() {
    document.querySelectorAll('.rh-cbb__pic').forEach(protect);
  }

  function blockRightClickAndDrag() {
    document.querySelectorAll('.rh-cbb__slider').forEach(function (slider) {
      if (slider.dataset.rhProtectBound === 'true') return;
      slider.dataset.rhProtectBound = 'true';
      slider.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  function init() {
    scan();
    blockRightClickAndDrag();
    var tries = 0;
    var t = setInterval(function () {
      scan();
      blockRightClickAndDrag();
      tries++;
      if (tries > 20) clearInterval(t);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
